"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoleOsoby = void 0;
/* eslint-disable react/no-array-index-key */
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var __1 = require("../../../../..");
var constants_1 = require("../../../../../constants");
var DruhOsobyUkonForm_1 = __importDefault(require("../../DruhyOsobField/components/DruhOsobyUkonForm"));
var getRoleOsoby = function (druhOsoby) {
    switch (druhOsoby) {
        case __1.TlumocniciDruhOsoby.tlumocnik:
            return { id: __1.UkonyRoleOsoby.Tlumocnik };
        case __1.TlumocniciDruhOsoby.prekladatel:
            return { id: __1.UkonyRoleOsoby.Prekladatel };
        default:
            return { id: __1.UkonyRoleOsoby.Zpracovatel };
    }
};
exports.getRoleOsoby = getRoleOsoby;
var PridatZpracovatelePopup = function (_a) {
    var zpracovatele = _a.zpracovatele, addZpracovatel = _a.addZpracovatel, selectedZpracovatel = _a.selectedZpracovatel, typUkonu = _a.typUkonu;
    var handleAdd = function (item, form) {
        var _a;
        var newValues = {
            idSubjekt: item.id,
            jmeno: item.jmeno,
            prijmeni: item.prijmeni,
            adresaSidla: (_a = item.adresa) === null || _a === void 0 ? void 0 : _a.adresaText,
            adresa: item.adresa,
            druh: { id: constants_1.UkonyTypOsoby.FyzickaOsobaPodnikajici },
            titulPred: item.titul,
            titulZa: item.titulZa,
            role: exports.getRoleOsoby(item.druhOsoby),
            ico: item.ico,
            datovaSchranka: item.datovaSchranka,
            druhOsobyNazev: item.druhOsoby === __1.TlumocniciDruhOsoby.prekladatel ? 'Soudní překladatel' : 'Soudní tlumočník',
            id: item.idOsoba,
        };
        addZpracovatel(newValues, form);
    };
    var defaultTlumocnik = function () {
        if (!selectedZpracovatel)
            return undefined;
        var def = {
            id: selectedZpracovatel.idSubjekt,
            jmeno: selectedZpracovatel.jmeno,
            prijmeni: selectedZpracovatel.prijmeni,
            titul: selectedZpracovatel.titulPred,
            titulZa: selectedZpracovatel.titulZa,
            adresa: __assign(__assign({}, selectedZpracovatel.adresa), { adresaText: selectedZpracovatel.adresaSidla }),
            ico: selectedZpracovatel.ico,
            druhOsobyNazev: selectedZpracovatel.druhOsobyNazev,
            datovaSchranka: selectedZpracovatel.datovaSchranka,
            idOsoba: selectedZpracovatel.id,
            druhOsoby: selectedZpracovatel.role.id === __1.UkonyRoleOsoby.Tlumocnik ? __1.TlumocniciDruhOsoby.tlumocnik : __1.TlumocniciDruhOsoby.prekladatel,
            odmenyNahrady: selectedZpracovatel.odmenyNahrady,
        };
        return def;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DruhOsobyUkonForm_1.default, { onSubmit: handleAdd, druhyOsob: [
                typUkonu === constants_1.DruhyUkonu.PrekladatelskyUkon || typUkonu === constants_1.DruhyUkonu.RevizniPrekladatelskyUkon ? __1.TlumocniciDruhOsoby.prekladatel : __1.TlumocniciDruhOsoby.tlumocnik,
            ], labels: {
                search: 'Zadejte jméno, IČO nebo ID datové schránky osoby',
                submit: (selectedZpracovatel ? 'Upravit' : 'Přidat') + " osobu",
            }, filterResult: function (_a) {
                var id = _a.id;
                return !ramda_1.includes(id, ramda_1.pluck('idSubjekt', zpracovatele));
            }, defaultSelected: defaultTlumocnik() })));
};
PridatZpracovatelePopup.defaultProps = {
    selectedZpracovatel: undefined,
};
exports.default = PridatZpracovatelePopup;
